class EventManager {
    constructor() {
        this.listeners = new Map();
    }

    // Register an event listener for a specific event
    on(event, callback) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, []);
        }
        this.listeners.get(event).push(callback);
    }

    // Remove an event listener for a specific event
    off(event, callback) {
        if (this.listeners.has(event)) {
            const listeners = this.listeners.get(event);
            const index = listeners.indexOf(callback);
            if (index !== -1) {
                listeners.splice(index, 1);
            }
        }
    }

    // Dispatch an event to all registered listeners
    emit(event, ...args) {
        if (this.listeners.has(event)) {
            const listeners = this.listeners.get(event);
            listeners.forEach((listener) => {
                listener(...args);
            });
        }
    }
}
export default EventManager;